export { default as Advantage } from './Advantage'
export { default as Faq } from './Faq'
export { default as Hero } from './Hero'
export { default as HeroHome } from './HeroHome'
export { default as Influencers } from './Influencers'
export { default as Lapa } from './Lapa'
export { default as NutritionistTime } from './NutritionistsTime'
export { default as Partners } from './Partners'
export { default as PlansCompare } from './PlansCompare'
export { default as SinglePlan } from './SinglePlan'
export { default as Price } from './Price'
export { default as Testimonials } from './Testimonials'
export { default as TypesTrainings } from './TypesTrainings'
export { default as HomeTraining } from './HomeTraining'
export { default as Video } from './Video'
